import { render, staticRenderFns } from "./PescaDesportivaInstitucional.vue?vue&type=template&id=d75a05e8&"
import script from "./PescaDesportivaInstitucional.vue?vue&type=script&lang=js&"
export * from "./PescaDesportivaInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports